import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Career from '../../static/js/career'
import Job from '../../components/job'
import Axios from 'axios'

const Fulltime = () => {
  const [openings, setOpnenings] = useState([])

  useEffect(() => {
    console.log('fetching recruitment data')
    // fetch data from API
    const getOpenings = async () => {
      await Axios.get('https://hrms-server.rean.in/hr/recruitment-api')
        .then(({ data }) => {
          console.log(data)
          if (data.status == 200) {
            setOpnenings(data.recruitmentData)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    }
    getOpenings()
  }, [])

  const LoadJobs = openings.map((opening, key) => {
    return <Job role={opening} />
  })

  return (
    <div className='fulltime'>
      <div className='container fulltime'>
        <div className='heading'>
          <h1>Available positions</h1>
        </div>

        <div className='row pos'>{LoadJobs}</div>
      </div>
    </div>
  )
}

export default Fulltime
